import gql from 'graphql-tag';

const getOutputsQuery = gql`
  query getOutputsSummary($videoId: String) {
    getOutputsSummary(videoId: $videoId) {
      createdAt
      outputs {
        outputId
        isMaster
        aspectRatio
        latestVersion
        outputCost
        name
        creditDelta
        status {
          name
        }
        versions {
          versionId
          versionNumber
          purchaseOrderId
          appliedAddons {
            BURN_IN_CAPTIONS {
              value
              status
              cost
              createdAt
            }
            SRT_CAPTIONS {
              value
              status
              cost
              createdAt
            }
            LONGFORM_SHORT {
              value
              status
              cost
              createdAt
            }
            CHROMA_KEY {
              value
              status
              cost
              createdAt
            }
            EXTRA_FOOTAGE {
              value
              status
              cost
              createdAt
            }
            RUSH_EDIT {
              value
              status
              cost
              createdAt
            }
            SUPER_RUSH_EDIT {
              value
              status
              cost
              createdAt
            }
            LONGFORM_MEDIUM {
              value
              status
              cost
              createdAt
            }
            LONGFORM_LONG {
              value
              status
              cost
              createdAt
            }
            VIDEO_OUTPUT {
              value
              status
              cost
              createdAt
            }
            VOICE_OVER_ARTIST {
              value
              status
              cost
              createdAt
            }
            VOICE_OVER_ARTISTS {
              cost
              artistId
              name
              duration
              status
              createdAt
              value
            }
            SUPERSIZE_MY_EDIT {
              value
              status
              cost
              addonId
              createdAt
            }
            DURATION {
              value
              status
              cost
              createdAt
            }
          }
        }
      }
    }
  }
`;

const getOutputs = () => ({
  query: getOutputsQuery,
  module: 'video',
  ignoreCache: true,
  buildVariables: ({ videoId }: any) => ({
    videoId
  })
});

export default getOutputs;
